exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.update[data-v-896deb02] {\n  transform: rotate(360deg);\n  animation: rotating-896deb02 1s linear infinite;\n}\n@keyframes rotating-896deb02 {\n0% {\n    transform: rotate(0);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports
